import React from 'react'
import { useRecoilValue } from 'recoil'
import { Box, LogoTheme, Text } from '@/presentation/components'
import { serviceOrderDetailState } from '@/presentation/pages/ServiceOrderDetail/components'
import { ServiceOrderDetailModality, ServiceOrderDetailStatus } from '@/domain/models'
import { styles } from './styles'

export const PageHeader: React.FC = () => {
  const serviceOrderDetail = useRecoilValue(serviceOrderDetailState)

  const makeTextStatus = (status: ServiceOrderDetailStatus): string => {
    return {
      A: 'Aberta',
      B: 'Fechada',
      F: 'Faturada'
    }[status]
  }

  const makeTextModality = (modality: ServiceOrderDetailModality): string => {
    return {
      M: 'Manutenção Corretiva',
      V: 'Vendas Instalação',
      P: 'Manutenção Preventiva',
      A: 'Vendas Ampliação',
      R: 'Retirada Equipamento',
      I: 'Interna'
    }[modality]
  }

  return (
    <Box style={styles.headerBox}>
      <Box>
        <LogoTheme height={80} />
      </Box>
      <Box>
        <Text style={styles.headerTitle}>OS {serviceOrderDetail.numOS}</Text>
        <Text>{makeTextModality(serviceOrderDetail.tipo)}</Text>
        <Text>{makeTextStatus(serviceOrderDetail.status)}</Text>
      </Box>
    </Box>
  )
}
